var render = function render(){var _vm=this,_c=_vm._self._c;return _c('team-form',{attrs:{"value":_vm.team}})
}
var staticRenderFns = []

export { render, staticRenderFns }